// import React, { useState } from "react";
// import { Modal, Form, Input, Select, DatePicker, Button, Tabs } from "antd";
// const { TabPane } = Tabs;
// const TimerPopup = ({ open, setOpen, clinicTiming }) => {
//   const [doctorTiming, setDoctorTiming] = useState(
//     clinicTiming?.[0]?.clinic_timing
//   );
//   const [activeNew, setActiveNew] = useState(0);
//   if (!open) return null;

//   const normal =
//     "bg-white border px-4 py-2 border-[#ccc] border-[1px] cursor-pointer hover:bg-primary hover:text-white mr-2 mb-2 transition-all duration-300 ease-in-out";
//   const active =
//     "bg-primary text-white border px-4 py-2 border-[#ccc] border-[1px] cursor-pointer hover:bg-primary hover:text-white mr-2 mb-2 transition-all duration-300 ease-in-out";
//   return (
//     <Modal open={open} footer={null} onCancel={() => setOpen(false)}>
//       <h1 className="font-primary font-bold text-[1.5rem] py-[4vh] text-primary">
//         Doctor Timings
//       </h1>
//       <div className="mb-4">
//         {clinicTiming && (
//           <div className="flex flex-wrap">
//             {clinicTiming?.map((item, idx) => (
//               <div
//                 className={activeNew === idx ? active : normal}
//                 key={idx}
//                 onClick={() => {
//                   setDoctorTiming(item?.clinic_timing);
//                   setActiveNew(idx);
//                 }}
//               >
//                 {item?.name}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//       <div>
//         {doctorTiming ? (
//           Object.entries(doctorTiming)
//             .slice(0, 7) // Limits the days to 7
//             .map(([day, timings], index) => (
//               <div
//                 key={index}
//                 style={{
//                   marginBottom: "15px",
//                   display: "grid",
//                   gridTemplateColumns: "100px auto",
//                   gap: "10px",
//                   alignItems: "start",
//                 }}
//               >
//                 <strong>{day}:</strong>
//                 <div>
//                   {Array.isArray(timings) && timings.length > 0 ? (
//                     timings.map((timing, idx) => (
//                       <div key={idx}>
//                         {timing.disabled ? (
//                           <span style={{ color: "red" }}>Closed</span>
//                         ) : (
//                           <span>
//                             Open: <strong>{timing.opening}</strong> - Close:{" "}
//                             <strong>{timing.closing}</strong>
//                           </span>
//                         )}
//                       </div>
//                     ))
//                   ) : (
//                     <span style={{ color: "red" }}>Closed</span>
//                   )}
//                 </div>
//               </div>
//             ))
//         ) : (
//           <p>No timings available</p>
//         )}
//       </div>
//     </Modal>
//   );
// };

// export default TimerPopup;

import React, { useState, useEffect } from "react";
import { Modal, Tabs } from "antd";

const { TabPane } = Tabs;

const TimerPopup = ({ open, setOpen, clinicTiming = [] }) => {
  const [doctorTiming, setDoctorTiming] = useState(null);

  useEffect(() => {
    if (clinicTiming.length > 0) {
      setDoctorTiming(clinicTiming[0]?.clinic_timing); // Set default timing when clinicTiming is available
    }
  }, [clinicTiming]);

  const handleTabChange = (key) => {
    setDoctorTiming(clinicTiming[key]?.clinic_timing);
  };

  if (!open) return null;

  return (
    <Modal open={open} footer={null} onCancel={() => setOpen(false)}>
      <h1 className="font-primary font-bold text-[1.5rem] bg-primary px-[20px] py-[4vh] text-white">
        Doctor Timings
      </h1>
      <div className="p-[20px]">
        {clinicTiming.length > 0 ? (
          <>
            <Tabs
              defaultActiveKey="0"
              onChange={handleTabChange}
              className="mb-4"
              tabBarGutter={16}
            >
              {clinicTiming.map((item, idx) => (
                <TabPane
                  tab={item?.name || `Clinic ${idx + 1}`}
                  key={idx}
                ></TabPane>
              ))}
            </Tabs>
            <div>
              {doctorTiming ? (
                Object.entries(doctorTiming)
                  .slice(0, 7) // Limits the days to 7
                  .map(([day, timings], index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: "15px",
                        display: "grid",
                        gridTemplateColumns: "100px auto",
                        gap: "10px",
                        alignItems: "start",
                      }}
                    >
                      <strong>{day}:</strong>
                      <div>
                        {Array.isArray(timings) && timings.length > 0 ? (
                          timings.map((timing, idx) => (
                            <div key={idx}>
                              {timing.disabled ? (
                                <span style={{ color: "red" }}>Closed</span>
                              ) : (
                                <span>
                                  Open: <strong>{timing.opening}</strong> -
                                  Close: <strong>{timing.closing}</strong>
                                </span>
                              )}
                            </div>
                          ))
                        ) : (
                          <span style={{ color: "red" }}>Closed</span>
                        )}
                      </div>
                    </div>
                  ))
              ) : (
                <p>No timings available</p>
              )}
            </div>
          </>
        ) : (
          <p>No clinic data available</p>
        )}
      </div>
    </Modal>
  );
};

export default TimerPopup;
